module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIzNCI+CiAgICA8cGF0aCBmaWxsPSIjNTU1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjA4MiAxNi44ODJsMTUuMzcxIDE1LjIwNy0xLjQyNiAxLjQxMUwuMjY4IDE2LjkybC4yNzMtLjI3LS4wNDEtLjA0MUwxNy4yODggMGwxLjQyOCAxLjQxM0wzLjA4MiAxNi44ODJ6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-left.svg
// module id = 597
// module chunks = 1